import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CalculatorModal from "./components/CalculatorModal";
import "./index.css";
import { Modal, Ripple, initTE } from "tw-elements";
import UnsuspiciousActivityModal from "./components/UnsuspiciousActivityModal";
import { AssessementContext } from "../../AssessmentContext";
import QuestionTypeWrapper from "./components/question-types/QuestionTypeWrapper";
import { toast } from "react-hot-toast";
import TimeOutModal from "./components/TimeOutModal";
import CompletedAssessmentModal from "./components/CompletedAssessmentModal";
import AssessmentTerminationModal from "./components/AssessmentTerminationModal";
import { useMutation } from "react-query";
import { api } from '../../../../../api';
import ScaleLoader from "../../components/ScaleLoader";
import SubmitConfirmModal from "./components/SubmitConfirmModal";
import PreviewExamModal from "./components/PreviewExamModal";
import QuestionIndexGotoModal from "./components/QuestionIndexGotoModal";
import { useDispatch, useSelector } from "react-redux";
import {
  addFailedSubmittedQuestion,
  addFlaggedQuestion, addQuestionDuration, addQuestionSavedAnswers,
  clearExamQuestions,
  clearFailedQuestions,
  clearQuestionDuration,
  clearRecentActiveExamData,
  flushSubmittedAnswers, updateExamQuestions, updateQuestionVisitCount, updateTimeLeft
} from '../../../../../features/candidate-exam/candidate-exam-slice'
import ResizeWindowModal from "./components/ResizeWindowWarningModal";
import { updatedSavedAnswerPayload } from './components/utils/transformSavedAnswerFormat';
import NetworkErrorModal from "./components/NetworkErrorModal";
import { exitFullScreen, getBatchQuestions, markBatchQuestions, toPlainAnwers, tranformToUniqueData } from "./components/utils/functions";
import platform from "platform";
import { exams } from "../../../../../api/exams";
import { decryptQuestionResponse } from "./components/utils/decryptData";
import { useTranslation } from "react-i18next";
import { useCustomToast } from "../../../../../components/customtoast/CustomToastProvider";
import RetryModal from "./components/RetryModal";
import ExamProctor from "../../../../../components/ExamProctor/ExamProctor";
import AssessmentEndedModal from "./components/AssessmentEndedModal";
import { getPipelineEndsAt, isAttemptClosedError, treatAlreadyCompletedAsSubmitted } from "../../../../../utils/pipelineWindow";

/** How long before the pipeline end unsaved answers are flushed (ms) */
const PIPELINE_END_FLUSH_LEAD_MS = 60 * 1000;

/** How often the proctoring status is checked during an assessment (ms) */
const PROCTORING_STATUS_INTERVAL_MS = /*30*/ 1 * 60 * 1000;

const categories_temp = [
  {
    "category_id": "a658d204-ac05-4528-95d2-ad9c62bf3a88",
    "title": "Aptitude & Skill"
  },
  {
    "category_id": "3fcabfdd-0ec2-4281-92d4-aabadef8ef12",
    "title": "Integrity"
  },
  {
    "category_id": "44a68a03-a1cd-4980-b4de-f2f3a1f9f7c6",
    "title": "Personality"
  }
]

const CandidateAssessment = ({ minutes, seconds, hours, totalSeconds, pause, restart }) => {

  const [openModal, setOpenModal] = useState(false)
  const { assessment, setAssessment } = useContext(AssessementContext)
  const [showunusualModal, SetShowUnusualModal] = useState(false)
  const user = JSON.parse(sessionStorage.getItem('user'))
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showResizeModal, setShowResizeModal] = useState(false)
  const [networkState, setNetworkState] = useState('normal')
  const container = document.querySelector(`#parent-container`)
  const location = useLocation()
  const navigate = useNavigate()
  const [timeSpend, setTimeSpend] = useState(0)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const customToast = useCustomToast();
  const currentLanguage = useSelector((state) => state.traslation.language);
  const questions = assessment?.assessements?.questions;
  // console.log({ questions }, 'questions from assessment pge');

  const examType = sessionStorage.getItem('examType')
  const [retryCount, setRetryCount] = useState(0)
  const [openRetryModal, setOpenRetryModal] = useState(false)
  const { questionSavedAnswers, questionsDuration, examQuestions } = useSelector(state => state.candidateExam)
  const logAssessmentMutation = useMutation(exams.logAssessment)
  const [attemptedQuestions, setAttemptedQuestions] = useState([])
  const [activeWarning, setActiveWarning] = useState(null)
  const [warningCount, setWarningCount] = useState(0)

  const proctorRef = useRef(null)
  const activeExam = JSON.parse(sessionStorage.getItem('active-assessment') || '{}')
  const allowProctoring = activeExam?.allow_proctoring === true

  // Check the proctoring status in the background every 30 minutes while the
  // assessment is ongoing, and warn the candidate when the violation scores
  // have changed since the last check
  const assessmentOngoing = !isSubmitting && !assessment?.isCompleted
    && !assessment?.isTimedOut && !assessment?.isTerminated && !assessment?.isEnded

  useEffect(() => {
    if (!assessmentOngoing) return
    const userId = user?.user?.user_id || window.sessionStorage.getItem("user_id")
    const assessmentId = activeExam?.assessment_id || window.sessionStorage.getItem("active-assessment-id")
    const userExamId = activeExam?.user_exam_id || window.sessionStorage.getItem("active-assessment-user-id")
    const storageKey = `proctoring_status_${userExamId}`

    const intervalId = setInterval(async () => {
      try {
        const response = await exams.getProctoringStatus({ userId, assessmentId, userExamId })
        const scores = {
          proctoring: response?.data?.proctoring_violation_score ?? 0,
          system: response?.data?.system_violation_score ?? 0,
        }
        const last = JSON.parse(sessionStorage.getItem(storageKey)) || { proctoring: 0, system: 0 }
        sessionStorage.setItem(storageKey, JSON.stringify(scores))
        if (scores.proctoring !== last.proctoring || scores.system !== last.system) {
          setWarningCount((count) => count + 1)
          setActiveWarning({
            type: 'proctoring_warning',
            icon: '⚠️',
            message: 'Proctoring violations were detected during your assessment. Please follow the assessment rules to avoid your assessment being flagged.'
          })
        }
      } catch (error) {
        // Background check: try again at the next interval
      }
    }, PROCTORING_STATUS_INTERVAL_MS)
    return () => clearInterval(intervalId)
  }, [assessmentOngoing])

  const isMobileDevice = () => {
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && window.innerWidth < 550;
  }

  const clearLocalExamQuestions = () => {
    const key = `examQuestions-${JSON.parse(window.sessionStorage.getItem("active-assessment"))?.assessment_id}`
    if (localStorage.getItem(key)) localStorage.removeItem(key)
  }

  // The server closed the attempt (pipeline ended): it was graded from the saved answers,
  // so stop the exam and never submit it again
  const handleAttemptClosed = () => {
    pause()
    toast.remove()
    setIsSubmitting(false)
    setOpenRetryModal(false)
    sessionStorage.setItem('exam-submit-status', 0)
    clearLocalExamQuestions()
    dispatch(clearRecentActiveExamData())
    dispatch(clearQuestionDuration())
    dispatch(clearExamQuestions())
    setAssessment({ ...assessment, isEnded: true, isTimedOut: false })
  }

  const finishExamMutation = useMutation(treatAlreadyCompletedAsSubmitted(exams.gradeAssessmentv2), {

    onSuccess: (response) => {
      //clear frontend saved questions.
      if (localStorage.getItem(`examQuestions-${JSON.parse(window.sessionStorage.getItem("active-assessment"))?.assessment_id
        }`
      )) {
        localStorage.removeItem(`examQuestions-${JSON.parse(window.sessionStorage.getItem("active-assessment"))?.assessment_id
          }`
        )
      }
      // Check if sshId, sshToken, and sshRoute are present in session storage
      const sshId = sessionStorage.getItem("sshId")
      const sshToken = sessionStorage.getItem("sshToken")
      const sshRoute = sessionStorage.getItem("sshRoute")
      toast.remove();
      setAssessment({ ...assessment, isCompleted: true, savedAnswers: [], questionNumber: 0 })
      pause()
      dispatch(clearRecentActiveExamData())
      dispatch(clearQuestionDuration())
      dispatch(clearExamQuestions())
      const exam = JSON.parse(sessionStorage.getItem("active-assessment"));
      const payload = {
        user_id: user?.user?.user_id,
        user_exam_id: exam?.user_exam_id,
        attempt: (sessionStorage.getItem("loginType") === 'join' || sessionStorage.getItem("fromRoute") === 'result') ?
          parseInt(sessionStorage.getItem('attempt_count'))
          : exam?.current_attempt,
        action_type: "submit assessment",
        request_payload: null,
        response_payload: { message: 'Assessment completed successfully', status: 200 }
      }
      // logAssessmentMutation.mutate({ payload })

      sessionStorage.setItem('level', 'easy')
      sessionStorage.setItem('exam-submit-status', 0)
      setIsSubmitting(false)
      if (sshId && sshToken && sshRoute) {
        window.location.href = `https://growth.serviceschoolhouse.com/courses-and-learning-path/${sshId}?token=${sshToken}`;
      }
      if (sessionStorage.getItem('exam-type') === 'mock') {
        navigate('/candidate/exam/result')
      }
    },
    onError: (response) => {
      if (retryCount > 3) {
        setNetworkState('poor')
      }
      setRetryCount(retryCount + 1)
      setOpenRetryModal(true)
      setIsSubmitting(false)
      const exam = JSON.parse(sessionStorage.getItem("active-assessment"));
      const payload = {
        user_id: user?.user?.user_id,
        user_exam_id: exam?.user_exam_id,
        attempt: (sessionStorage.getItem("loginType") === 'join' || sessionStorage.getItem("fromRoute") === 'result') ?
          parseInt(sessionStorage.getItem('attempt_count'))
          : exam?.current_attempt,
        action_type: "submit assessment",
        request_payload: null,
        response_payload: {
          message: response?.response?.data?.message ||
            'There is an issue sending your assessment to the server no response message from the server..',
          status: response?.response?.status
        }
      }
      logAssessmentMutation.mutate({ payload })
      toast.remove();
      toast.error('There is an issue sending your assessment to the server.. reload the page logout and Log in to re-submit')
    },
    onMutate: () => {
      toast.loading(t('submitting-exam'))
    }
  })

  const flagExamQuestionMutation = useMutation(api.flAgQuestion, {
    onSuccess: () => {
      toast.remove();
      toast.success(t('question-flagged'))
    },
    onError: () => {
      toast.remove();
      toast.error(t('error-unknown'))
    },
    onMutate: () => {
      toast.loading(t('flagging-question'))
    }
  })

  const sentExamErrorLogMutation = useMutation(api.sentExamErrorLog, {
    onSuccess: (data) => {
      setNetworkState('poor')
      //  setTimeout( () => {
      //       exitFullScreen()
      //       navigate('/')
      // }, 60000 )
    },
  })

  const getQuestionsmutation = useMutation(exams.getExamQuestionsv2, {
    onSuccess: async (data) => {
      let response = data
      const exam = JSON.parse(sessionStorage.getItem("active-assessment"));
      const payload = {
        user_id: user?.user?.user_id,
        user_exam_id: exam?.user_exam_id,
        attempt: (sessionStorage.getItem("loginType") === 'join' || sessionStorage.getItem("fromRoute") === 'result') ?
          parseInt(sessionStorage.getItem('attempt_count'))
          : exam?.current_attempt,
        action_type: "submit assessment",
        request_payload: null,
        response_payload: { message: 'Questions fetched successfully', status: 200 }
      }
      logAssessmentMutation.mutate({ payload })

      const encryptedData = data?.data?.encryptedData; // From encryptData.encryptedData
      const ivHex = data?.data?.iv; // From encryptData.iv
      const secretKeyHex = process.env.REACT_APP_ENCRYPTION_KEY;
      //const response = await decryptQuestionResponse({ encryptedData, ivHex, secretKeyHex,})
      const questionResponse = data?.data?.questions //response?.questions?.length ? response?.questions : [];  
      // console.log(questionResponse, 'questionResponse from getQuestionsmutation');

      if (parseInt(sessionStorage.getItem('transform-question-level'))) {
        // console.log('transform-question-level', 1);

        sessionStorage.setItem('transform-question-level', 0)
        setAssessment({
          ...assessment,
          assessements: { questions: questionResponse },
        })
      }
      else {
        //compare between current question and prevoius saved questions
        const questions = questionResponse?.filter(q => {
          return q?.answers?.some(ans => ans?.status === true)
        })
        if (examQuestions?.length) {
          if (questions?.length === 0) {
            //sync client answers
            const client_answers = toPlainAnwers(examQuestions)
            if (client_answers.length) updateAnswers(client_answers, questionResponse)
          }
          else {
            //check for unsync questions and retry submitting
            const client_answers = toPlainAnwers(examQuestions)
            const server_answers = toPlainAnwers(questions)
            const unsynced_answers = client_answers.filter((client_answer) => {
              return !server_answers.some((server_answer) => {
                return ((client_answer.question_id === server_answer.question_id)
                  && (client_answer.answer_id === server_answer.answer_id)
                );
              })
            });
            //update answers
            if (unsynced_answers?.length) updateAnswers(unsynced_answers, questionResponse)
            //finish assessment
            else {
              //finish exam
              return console.log({ attempt: JSON.parse(window.sessionStorage.getItem("active-assessment"))?.current_attempt || sessionStorage.getItem('attempt_count') }, 'attempt from getQuestionsmutation');

              finishExamMutation.mutate({
                userId: user?.user?.user_id || window.sessionStorage.getItem("user_id"),
                examId: sessionStorage.getItem("active-exam-id"),
                assessmentId: JSON.parse(window.sessionStorage.getItem("active-assessment"))?.assessment_id,
                userExamId: window.sessionStorage.getItem("active-assessment-user-id"),
                attempt: JSON.parse(window.sessionStorage.getItem("active-assessment"))?.current_attempt || sessionStorage.getItem('attempt_count')
              })
            }
          }
        }
      }
    },
    onError: (error) => {
      let response = error
      const exam = JSON.parse(sessionStorage.getItem("active-assessment"));
      const payload = {
        user_id: user?.user?.user_id,
        user_exam_id: exam?.user_exam_id,
        attempt: (sessionStorage.getItem("loginType") === 'join' || sessionStorage.getItem("fromRoute") === 'result') ?
          parseInt(sessionStorage.getItem('attempt_count'))
          : exam?.current_attempt,
        action_type: "submit assessment",
        request_payload: null,
        response_payload: {
          message: response?.response?.data?.message ||
            'There is an issue fetching questions, no response message from the server..',
          status: response?.response?.status
        }
      }
      logAssessmentMutation.mutate({ payload })
    }
  });

  const updateAnswersMutation = useMutation(exams.updateAnswersv2, {
    onSuccess: (response) => {
      setOpenRetryModal(false)
      toast.success('Answers saved successfully')
      const answered_questions_ids = response?.data?.answered_question_id
      setAttemptedQuestions(answered_questions_ids)
      //--------------------------------------------------------------------------------------------//
      //check for unsynced answers based new flow for catching
      const unsyncQuestionsRaw = sessionStorage.getItem(`unsyncQuestionsParsed`)
      if (unsyncQuestionsRaw) {
        const unsyncQuestions = JSON.parse(unsyncQuestionsRaw)
        if (unsyncQuestions?.length) {
          const unattempted = unsyncQuestions?.filter(q =>
            !answered_questions_ids?.includes(q?.id)
          );
          if (unattempted?.length) {
            const unsynced_answers = toPlainAnwers(unattempted);
            if (unsynced_answers?.length) {
              setTimeout(() => {
                updateAnswers(unsynced_answers);
                sessionStorage.removeItem(`unsyncQuestionsParsed`)
                localStorage.removeItem(`examQuestions-${JSON.parse(window.sessionStorage.getItem("active-assessment"))?.assessment_id
                  }`);
              }, 3000);
            }
          }
        }
      }
      //-----------------------------------------------------------------------------
      //restart the timer in case if there is any time added
      //restart(new Date().getTime() + response?.data?.time_left * 60 * 1000 )
      if (sessionStorage.getItem('examType') === 'adaptive') {
        //    const isPassed = markBatchQuestions(
        //       getBatchQuestions(questions,questionSavedAnswers), questionSavedAnswers
        //    )?.every( question => question?.status === true )
        //  console.log(isPassed,'isPassed', markBatchQuestions(
        //    getBatchQuestions(questions,questionSavedAnswers), questionSavedAnswers
        // ));

        const batchQuestions = markBatchQuestions(
          getBatchQuestions(questions, questionSavedAnswers), questionSavedAnswers
        )
        const isPassed = (batchQuestions?.filter(question => question?.status === true)?.length >= batchQuestions?.length - 1)

        const updateCurrentLevel = () => {
          const currentLevel = questions[assessment?.questionNumber]?.level
          const levels = ['easy', 'intermediate', 'hard']
          const currentLevelIndex = levels.indexOf(currentLevel)
          if (isPassed) return levels[currentLevelIndex !== 2 ? currentLevelIndex + 1 : 2]
          else return levels[currentLevelIndex !== 0 ? currentLevelIndex - 1 : 0]
        }
        sessionStorage.setItem('transform-question-level', 1)
        if ((questions?.length - 5) > assessment?.questionNumber) {
          //  console.log('update question difficulty');
          sessionStorage.setItem('exam-submit-status', 0)
          //  getQuestionsmutation.mutate({
          //     userId: user?.user?.user_id || window.sessionStorage.getItem("user_id"),
          //     examId: sessionStorage.getItem("active-exam-id"), 
          //     userExamId: window.sessionStorage.getItem("active-assessment-user-id"),
          //     assessmentId: JSON.parse(window.sessionStorage.getItem("active-assessment"))?.assessment_id ,
          //     showOnlyQuestions: false,
          //     level: updateCurrentLevel(),
          //     language: currentLanguage,
          //     switchQuestion: true,
          //     number_of_attempts : sessionStorage.getItem("loginType") === 'join' 
          //     || sessionStorage.getItem("fromRoute") === 'result' ? 
          //        parseInt(sessionStorage.getItem('attempt_count'))
          //     : JSON.parse(window.sessionStorage.getItem("active-assessment"))?.current_attempt,
          //   });
        }
      }

      toast.remove();
      dispatch(flushSubmittedAnswers())
      if (parseInt(sessionStorage.getItem('is-network-failure'))) {
        sessionStorage.setItem('is-network-failure', '0')
        dispatch(clearFailedQuestions())
      }
      if (parseInt(sessionStorage.getItem('exam-submit-status'))) {
        //finish exam
        finishExamMutation.mutate(
          {
            userId: user?.user?.user_id || window.sessionStorage.getItem("user_id"),
            examId: sessionStorage.getItem("active-exam-id"),
            assessmentId: JSON.parse(window.sessionStorage.getItem("active-assessment"))?.assessment_id,
            userExamId: window.sessionStorage.getItem("active-assessment-user-id"),
            attempt: JSON.parse(window.sessionStorage.getItem("active-assessment"))?.current_attempt || sessionStorage.getItem('attempt_count')
          }
        )
      }
    },
    onError: (error) => {
      if (isAttemptClosedError(error)) return handleAttemptClosed()
      if (parseInt(sessionStorage.getItem('exam-submit-status'))) {
        if (retryCount > 2) {
          setNetworkState('poor')
        }
        setIsSubmitting(false)
        setOpenRetryModal(true)
        setRetryCount(retryCount + 1)
      }
      else if (error?.response?.status === 400 && error?.response?.data?.terminate === true) {
        setAssessment({ ...assessment, isTerminated: true })
        // console.log('test', { error: error?.response })
      }
   
      else if (error?.response?.status === 403) {
       if(error?.response?.data?.message)  customToast.error(error?.response?.data?.message)  
      }
      else customToast.error(`
      Seems there is an issue with your internet connection which distrub saving your answers... 
      reload the page logout and resolve your network then Log in to continue
      `)
      let response = error
      const exam = JSON.parse(sessionStorage.getItem("active-assessment"));
      const payload_ = {
        user_id: user?.user?.user_id,
        user_exam_id: exam?.user_exam_id,
        attempt: (sessionStorage.getItem("loginType") === 'join' || sessionStorage.getItem("fromRoute") === 'result') ?
          parseInt(sessionStorage.getItem('attempt_count'))
          : exam?.current_attempt,
        action_type: "submit assessment",
        request_payload: null,
        response_payload: {
          message: response?.response?.data?.message ||
            'There is an issue sending your assessment answers to the server no response message from the server..',
          status: response?.response?.status
        }
      }
      logAssessmentMutation.mutate({ payload: payload_ })

      const deviceInfo = platform.parse(navigator.userAgent)
      let connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      const assessmentId = JSON.parse(sessionStorage.getItem('active-assessment')).assessment_id || window.sessionStorage.getItem("active-assessment-id")

      const getDeviceType = () => {
        const userAgent = navigator.userAgent;
        if (/mobile/i.test(userAgent)) {
          return "Mobile";
        } else if (/tablet/i.test(userAgent)) {
          return "Tablet";
        } else {
          return "Desktop";
        }
      }
      const payload = {
        appName: "Testassessify",
        deviceInfo: `${deviceInfo.description} device type = ${getDeviceType()
          }${connection ? `Network Effective connection type: ${connection.effectiveType
            } Downlink speed: ${connection.downlink} Mb/s` : ''}`,
        browserInfo: `${deviceInfo.name} Version = ${deviceInfo.version}`,
        platformInfo: deviceInfo.ua,
        causeOfError: error?.response?.message,
        url: window.location.href,
        payload: {
          user_group_id: sessionStorage.getItem("user_group_id"),
          assessment_id: assessmentId,
          data: {
            ...updatedSavedAnswerPayload(
              [...questionSavedAnswers.map(answer => {
                return {
                  duration: answer?.duration,
                  answer_id: answer?.answer_id,
                  question_id: answer?.question_id,
                  answer_text: answer?.answer_text,
                }
              })],
              questionsDuration,
              questions,
            ),
            time_left: totalSeconds,
          }
        },
        response: error?.response?.message,
        responseCode: error?.response?.status
      }

      if (!window.navigator.onLine) {
        sentExamErrorLogMutation.mutate({
          ...payload, response: 'Request failed',
          responseCode: null,
          causeOfError: "internet disconnected (no connection)"
        })
        setNetworkState('poor')
        // toast.error(t('error-no-internet'))
        //  setTimeout( () => {
        //       exitFullScreen()
        //       navigate('/')
        // }, 60000 )
      }
      // else if(error.message.includes('502')){
      //   sentExamErrorLogMutation.mutate({
      //     ...payload, response: 'Internal server error',
      //     responseCode: '502', causeOfError: 'Server error 502'
      //   })
      // }
      // else sentExamErrorLogMutation.mutate(payload)
    }
  })

  const displayUnsualActivityModal = () => {
    //document.querySelector('button.unusual-activity-button').click()   
    const actualDeviceWidth = parseInt(sessionStorage.getItem('device-width'))
    const actualDeviceHeight = parseInt(sessionStorage.getItem('device-height'))

    if ((window.innerWidth !== actualDeviceWidth)) {
      if (!isMobileDevice()) {
        SetShowUnusualModal(true)
        //toast.error(t('error-resize-browser'))
      }
    }
    else if (actualDeviceHeight === window.innerHeight) {
      setShowResizeModal(true)
      sessionStorage.setItem('frudeType', 'keystroke_anomaly')
    }
  }
  /* reusable function for updating answers */
  let updateAnswers = (answers) => {
    // Take a proctoring snapshot alongside answer submission
    if (allowProctoring && proctorRef.current) {
      proctorRef.current.takeSnapshot()
    }
    updateAnswersMutation.mutate({
      userId: JSON.parse(sessionStorage.getItem('user'))?.user?.user_id || window.sessionStorage.getItem("user_id"),
      assessmentId: window.sessionStorage.getItem("active-assessment-id"),
      userExamId: window.sessionStorage.getItem("active-assessment-user-id"),
      data: {
        ...updatedSavedAnswerPayload(
          [...answers.map(answer => {
            return {
              duration: answer?.duration,
              answer_id: answer?.answer_id,
              question_id: answer?.question_id,
              answer_text: answer?.answer_text,
            }
          })],
          questionsDuration,
          questions,
        ),
        time_left: totalSeconds,
        attempt: JSON.parse(window.sessionStorage.getItem("active-assessment"))?.current_attempt || sessionStorage.getItem('attempt_count'),
        //  sessionStorage.getItem("loginType") === 'join'
        //   || sessionStorage.getItem("fromRoute") === 'result'
        //   ?
        //   parseInt(sessionStorage.getItem('attempt_count'))
        //   : JSON.parse(window.sessionStorage.getItem("active-assessment"))?.current_attempt,
      }
    },
    )
  }

  // Flush unsaved answers shortly before the pipeline end and again at the end, since the
  // server grades an ended attempt only from the answers already saved
  const flushUnsavedAnswersRef = useRef(null)
  flushUnsavedAnswersRef.current = () => {
    if (questionSavedAnswers?.length && !updateAnswersMutation.isLoading) updateAnswers(questionSavedAnswers)
  }

  useEffect(() => {
    const pipelineEndsAt = getPipelineEndsAt()
    if (!pipelineEndsAt) return
    const timeoutIds = [pipelineEndsAt - PIPELINE_END_FLUSH_LEAD_MS, pipelineEndsAt]
      .map(at => at - Date.now())
      .filter(delay => delay > 0)
      .map(delay => setTimeout(() => flushUnsavedAnswersRef.current?.(), delay))
    return () => timeoutIds.forEach(clearTimeout)
  }, [])

  useEffect(() => {
    localStorage.setItem('saved-assessment-user-id',
      user?.user?.user_id || window.sessionStorage.getItem("user_id"),
    )
    // clear recently submitted answers
    setTimeout(() => {
      dispatch(flushSubmittedAnswers())
    }, 500)
  }, [])

  useEffect(() => {

    const single_assessment = questions[assessment.questionNumber]
    dispatch(addQuestionDuration(
      {
        id: single_assessment?.id,
        questionNumber: assessment?.questionNumber + 1,
        duration: timeSpend
      }
    ))
    dispatch(updateExamQuestions(questions))
    sessionStorage.setItem('client_side_time_left', totalSeconds)
    sessionStorage.setItem('level', questions[assessment?.questionNumber]?.level)
  }, [timeSpend])

  useEffect(() => {
    const single_assessment = questions[assessment.questionNumber]
    dispatch(updateQuestionVisitCount(single_assessment?.id))
    setTimeSpend(0)
    /* automatically submit answers once 5 question are answered. */
    if (questionSavedAnswers?.length) {
      if (tranformToUniqueData(questionSavedAnswers)?.length >= 5) {
        updateAnswers(questionSavedAnswers)
        console.log('Automatically submitted answers after 5 questions');
      }
    }
  }, [assessment.questionNumber])

  useEffect(() => {
    const single_assessment = questions[assessment.questionNumber]
    //if(assessment.questionNumber === questions?.length - 1){
    const updated_saved_answers = single_assessment?.answers?.filter(ans => ans?.status === true)

    if (updated_saved_answers?.length) {
      dispatch(addQuestionSavedAnswers([updated_saved_answers.map(answer => {
        return {
          answer_id: answer?.id,
          question_id: single_assessment?.id,
          answer_text: answer?.text,
          question_type: single_assessment.type
        }
      })]))
    }
    // check and submit assessment on time out 
    if (hours === 0 && minutes === 0 && seconds === 0 && !assessment?.isEnded) {
      setAssessment({ ...assessment, isTimedOut: true });
    }
    //  }
  }, [timeSpend])

  useEffect(() => {
    // Start the timer when the component mounts
    const intervalId = setInterval(() => {
      setTimeSpend((prevSeconds) => prevSeconds + 1);
    }, 1000)
    // Clear the interval when the component unmounts to avoid memory leaks
    return () => clearInterval(intervalId);
  }, [assessment.questionNumber,]);

  useEffect(() => {
    // Hide chatbot and contact us buttons when exam is taken
    const hideChatbot = () => {
      const selectors = [
        '.woot-widget-bubble',
        '.woot-elements--right',
        '#chatwoot-widget-container',
        '.chatbot-button',
        '[aria-label="Toggle Chat"]'
      ];

      selectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
          if (el instanceof HTMLElement) {
            el.style.display = 'none';
            el.style.visibility = 'hidden';
          }
        });
      });
    };

    hideChatbot();
    const interval = setInterval(hideChatbot, 2000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    container.scrollTo({ top: 0, })
    sessionStorage.setItem('last_asessement_id', assessment?.assessements?.assessment_id);
    sessionStorage.setItem('last_asessement_user_group_id', sessionStorage.getItem("user_group_id"));
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        // User has switched to another tab or minimized the browser window        
        // toast.error(t('error-new-program'))
        SetShowUnusualModal(true)
        sessionStorage.setItem('frudeType', 'browser_lock')
      } else {
        // User has returned to the tab
        //  toast.error(t('error-back'))
        SetShowUnusualModal(true)
        sessionStorage.setItem('frudeType', 'screen_switch')
      }
    };

    const handlePrint = (event) => {
      event.preventDefault(); // prevent the print dialog from opening
      //toast.error(t('error-printing'))
      SetShowUnusualModal(true)
      sessionStorage.setItem('frudeType', 'screen_switch')
    }

    const navigation = () => {
      window.location.assign(window.location.href.replace(
        'candidate-assessment',
        sessionStorage.getItem('active-page-view') !== 'mock-page' ?
          'view-assessments' : 'view-practice-exams'
      ))
    }

    window.onbeforeprint = handlePrint;
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('load', navigation)

    return () => {
      window.onbeforeprint = null;
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [])


  useEffect(() => {
    initTE({ Modal, Ripple });
    window.addEventListener('resize', displayUnsualActivityModal)
    // continue exam from last question viewed
    const last_question_viewed = parseInt(sessionStorage.getItem('last_question_viewed')) > 0 ?
      parseInt(sessionStorage.getItem('last_question_viewed')) : 0
    if (last_question_viewed && (last_question_viewed <= questions?.length)) {
      setAssessment({
        ...assessment, inEditMode: true,
        activeQuestion: assessment.assessements.questions[
          last_question_viewed
        ],
        questionNumber: last_question_viewed,
        questionType: assessment.assessements.questions[
          last_question_viewed
        ]['type'],
      })
    }

    return () => {
      window.removeEventListener('resize', displayUnsualActivityModal);
    }
  }, [])

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  //-------------------------------------------------------------------------------------------------------//
  // move to next question
  //--------------------------------------------------------------------------------------------------------//

  const moveToNextQuestion = () => {
    sessionStorage.setItem('exam-submit-status', 0)

    if (assessment.questionNumber < questions?.length - 1) {
      setAssessment({
        ...assessment, inEditMode: false,
        activeQuestion: assessment.assessements.questions[
          assessment.questionNumber + 1
        ],
        questionNumber: assessment.questionNumber + 1,
        questionType: assessment.assessements.questions[
          assessment.questionNumber + 1
        ]['type'],
        // savedAnswers:        
      })
    }


    //const answers = assessment.savedAnswers.filter( answer => answer.question_id === single_assessment.id)
    const assessmentId = JSON.parse(sessionStorage.getItem('active-assessment'))?.assessment_id || window.sessionStorage.getItem("active-assessment-id")
    //submit exam answer in batches after completing every 5 question
    const active_question_number = assessment?.questionNumber + 1

    if (((active_question_number) % 5) === 0) {
      if (active_question_number === (questions?.length)) {
        // toast.success('submiting...')
      }
      else {
        //submit 5 question answers (update answers endpoint)
        if (questionSavedAnswers.length) {
          /* update answers endpoint in batches is already handled by use effect hook */
          //updateAnswers(questionSavedAnswers)
        }
      }
    }
    container.scrollTo({ top: 0, })
    setTimeSpend(0)
  }
  //-------------------------------------------------------------------------------------------------------//
  // move to previous question
  //--------------------------------------------------------------------------------------------------------//
  const moveToPrevQuestion = () => {
    sessionStorage.setItem('exam-submit-status', 0)
    const active_question_number = assessment?.questionNumber + 1
    if (((active_question_number) % 5) === 0) {
      dispatch(flushSubmittedAnswers())
    }
    if (assessment.questionNumber > 0) {
      setAssessment({
        ...assessment, inEditMode: true,
        activeQuestion: assessment.assessements.questions[
          assessment.questionNumber - 1
        ],
        questionNumber: assessment.questionNumber - 1,
        questionType: assessment.assessements.questions[
          assessment.questionNumber - 1
        ]['type'],
      })

    }
    container.scrollTo({ top: 0, })
    setTimeSpend(0)
  }

  const gotoQuestion = (index) => {
    setAssessment({
      ...assessment, inEditMode: true,
      activeQuestion: assessment.assessements.questions[
        index
      ],
      questionNumber: index,
      questionType: assessment.assessements.questions[
        index
      ]['type'],
    })
    container.scrollTo({ top: 0, })
    setTimeSpend(0)
  }

  const flagIncorrectQuestion = (id) => {
    flagExamQuestionMutation.mutate(id)
    dispatch(addFlaggedQuestion(id))
  }

  const submitAssessment = (single_assessment) => {
    if (!window.navigator.onLine) {
      return customToast.error('internet disconnected (no connection) please check your internet connection and try again')
    }
    setIsSubmitting(true)
    const active_question_number = assessment?.questionNumber + 1
    const assessmentId = JSON.parse(sessionStorage.getItem('active-assessment'))?.assessment_id || window.sessionStorage.getItem("active-assessment-id")
    if (active_question_number === (questions?.length)) {
      //submit the rest of the question if is less than 5
      sessionStorage.setItem('exam-submit-status', 1)
      sessionStorage.setItem('transform-question-level', 0)
      // console.log({attemptedQuestions, questions});

      if (examQuestions?.length) {
        const unattempted = examQuestions?.filter(q =>
          !attemptedQuestions?.includes(q?.id)
        );
        const attempted = toPlainAnwers(examQuestions)
        if (attempted?.length) updateAnswers(attempted)
        // if(unattempted?.length){
        //     //check for unsync questions and retry submitting
        //    const unsynced_answers = toPlainAnwers(unattempted)
        //   //update answers
        //   if(unsynced_answers?.length) updateAnswers(unsynced_answers)
        // }

      }
      else {
        //finish assessment             
        finishExamMutation.mutate({
          userId: user?.user?.user_id || window.sessionStorage.getItem("user_id"),
          examId: sessionStorage.getItem("active-exam-id"),
          assessmentId: JSON.parse(window.sessionStorage.getItem("active-assessment"))?.assessment_id,
          userExamId: window.sessionStorage.getItem("active-assessment-user-id"),
          attempt: JSON.parse(window.sessionStorage.getItem("active-assessment"))?.current_attempt || sessionStorage.getItem('attempt_count')
        })
      }
      // return
      // getQuestionsmutation.mutate({
      //    userId: user?.user?.user_id || window.sessionStorage.getItem("user_id"),
      //    examId: sessionStorage.getItem("active-exam-id"), 
      //    assessmentId: JSON.parse(window.sessionStorage.getItem("active-assessment"))?.assessment_id ,
      //    userExamId: window.sessionStorage.getItem("active-assessment-user-id"),
      //    showOnlyQuestions: true,
      //    language: currentLanguage,
      //    number_of_attempts : (sessionStorage.getItem("loginType") === 'join' || sessionStorage.getItem("fromRoute") === 'result') ? 
      //     parseInt(sessionStorage.getItem('attempt_count'))
      //   : JSON.parse(window.sessionStorage.getItem("active-assessment"))?.current_attempt,
      //  });
    }
  }

  const brandedClient = JSON.parse(sessionStorage.getItem("client") || '{}');

  return (
    <div className="flex assessment-page-container"> {!finishExamMutation.isLoading ?
      <>  {networkState === 'poor' ? <NetworkErrorModal /> : null}
        {/* Warning notification banner */}
        {activeWarning && (
          <div
            style={{
              position: "fixed",
              bottom: 100,
              right: 16,
              width: 340,
              zIndex: 10001,
              animation: "slideInRight 0.3s ease-out",
            }}
          >
            <div
              style={{
                background:
                  activeWarning.type === "multiple_faces" || activeWarning.type === "no_face"
                    ? "linear-gradient(135deg, #991b1b, #dc2626)"
                    : "linear-gradient(135deg, #92400e, #d97706)",
                borderRadius: 12,
                padding: "14px 16px",
                boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
                color: "#fff",
              }}
            >
              <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
                <span style={{ fontSize: 22, lineHeight: 1, flexShrink: 0, marginTop: 1 }}>
                  {activeWarning.icon}
                </span>
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      fontWeight: 700,
                      fontSize: 13,
                      marginBottom: 4,
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Monitoring Active
                  </div>
                  <p style={{ fontSize: 12, lineHeight: 1.4, margin: 0, opacity: 0.95 }}>
                    {activeWarning.message}
                  </p>
                  <div
                    style={{
                      marginTop: 8,
                      fontSize: 11,
                      opacity: 0.7,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>Warning #{warningCount}</span>
                    <span>This incident has been recorded</span>
                  </div>
                </div>
                <button
                  onClick={() => setActiveWarning(null)}
                  style={{
                    background: "rgba(255,255,255,0.2)",
                    border: "none",
                    borderRadius: 6,
                    color: "#fff",
                    cursor: "pointer",
                    padding: "2px 6px",
                    fontSize: 16,
                    lineHeight: 1,
                    flexShrink: 0,
                  }}
                >
                  ×
                </button>
              </div>
            </div>
          </div>
        )}
        {allowProctoring && !isSubmitting && !assessment?.isCompleted && !assessment?.isEnded && (
          <ExamProctor
            ref={proctorRef}
            user_id={user?.user?.user_id || window.sessionStorage.getItem("user_id")}
            user_exam_id={activeExam?.user_exam_id || window.sessionStorage.getItem("active-assessment-user-id")}
            assessment_id={activeExam?.assessment_id || window.sessionStorage.getItem("active-assessment-id")}
            onFlag={(result) => {
              //console.warn("Proctoring flag:", result);
            }}
          />
        )}
        {<RetryModal
          isOpen={openRetryModal}
          setIsOpen={setOpenRetryModal} retry={submitAssessment}

        />}
        <div className="w-[33px] md:w-[48px]"></div>
        <section style={{ width: 'calc(100vw - 50px)' }} className='md:ml-5 candidate-assessment jumbotron bg-white px-2 md:px-4 p-4'>
          {
            //  <span className='mx-2'>/</span>
            //  <Link to={'/candidate/assessments/candidate-assessment'} className='text-md text-customGreen'>
            //      {t('candidate-assessment')}
            //  </Link>
          }
          {/* <span className="text-lg ml-5">
                    Question Level: {questions[assessment?.questionNumber]?.level}
                  </span>     */}
          <div style={{ backgroundColor: brandedClient?.primary_colour || undefined }} className='mt-8 py-12 bg-darkBlue px-5 text-white rounded-lg'>
            <h5 className='text-2xl flex justify-between'>
              {
                assessment?.activeAssessment?.assessment_title
                || JSON.parse(window.sessionStorage.getItem("active-assessment"))?.title
                || JSON.parse(sessionStorage.getItem('active-assessment'))?.exam_name
              }
              <span className='text-xl flex items-center'>
                <i className='text-2xl bi bi-clock-history mr-2'>
                </i>   {hours < 10 ? `0${hours}` : hours}: {minutes < 10 ? `0${minutes}` : minutes}: {seconds < 10 ? `0${seconds}` : seconds}
              </span>
            </h5>
            <p className='text-[12px]'>
              {t('attempt-all-questions')}
            </p>
            <div className='mt-4 bg-white py-4 rounded-lg text-gray-900 px-4 flex justify-between'>
              <span>
                {t('question')} {assessment.questionNumber + 1} of {questions?.length}
              </span>
              <div className="flex justify-end items-center">
                <span className="text-lg font-semibold mr-10">
                  Category: {categories_temp?.find((category) => category?.category_id === assessment?.activeQuestion?.category_id)?.title || ''}
                </span>
                <span className="font-semibold"> {t('section')}: &nbsp;{assessment.activeQuestion?.section?.title}</span>
              </div>
            </div>
          </div>
          {
            assessment?.activeQuestion?.direction?.title &&
            <div className='mt-8 mb-5 border bg-gray-100 border-gray-300 text-lg py-0 px-0 rounded-lg'>
              <p className="p-4 text-lg italic"
                dangerouslySetInnerHTML={{
                  __html: assessment?.activeQuestion?.direction?.content
                }}
              />
            </div>
          }
          <div className='mt-12'>
            {
              questions?.map((single_assessment, index) => {
                if (assessment.questionNumber === index) {
                  return <React.Fragment key={index} >
                    <h5 className='text-xl mb-3'>
                      {t('question')}  (
                      <span className=' text-xl px-1'>
                        {assessment.questionNumber + 1}
                      </span>
                      <span className='text-green-500 text-xl pl-1'>of </span>
                      &nbsp;{questions?.length} )
                    </h5>
                    <p
                      className='text-[17px]'
                      dangerouslySetInnerHTML={{ __html: (single_assessment['text']) }}
                    />
                    <h5 className='text-xl mt-12 mb-3'>{t('options')}</h5>
                    <QuestionTypeWrapper
                      setShowUnusualModal={SetShowUnusualModal}
                      single_assessment={single_assessment}
                    />


                    {/* <div className="mt-[130px] flex  justify-between md:justify-end items-center">
                        
                      
                        <QuestionIndexGotoModal
                          id={`leftBottomModal-${single_assessment.id}`}
                          questions={questions}
                          activeQuestion={assessment.questionNumber}
                          gotoQuestion={gotoQuestion}
                          isLoading={getQuestionsmutation.isLoading}
                        />
                        <button
                          onClick={() =>
                            flagIncorrectQuestion(single_assessment.id)
                          }
                          className="bg-gray-200 bi bi-flag py-3 px-3 mr-3 md:mr-12 rounded-lg  text-lg"
                        >
                          &nbsp; {t("flag-question-text")}
                        </button>
                        <div className="flex ml-[5px] sm:ml-0 justify-between items-center ">
                          <button
                            className="bi bi-calculator-fill text-green-900 text-4xl mr-4 md:mr-16"
                            onClick={handleOpenModal}
                          ></button>
                          {openModal && (
                            <CalculatorModal closeModal={handleCloseModal} />
                          )}

                          <button
                            onClick={() =>
                              moveToPrevQuestion(single_assessment)
                            }
                            className="py-3 px-8 md:px-16 rounded-lg text-darkBlue  hover:text-white active:text-white hover:bg-darkBlue active:bg-darkBlue    border border-darkBlue text-lg"
                          >
                            <i className="bi bi-chevron-double-left mr-3"></i>{" "}
                            {t("prev")}
                          </button>
                          {questions.length - 1 !== index ? (
                            <button
                              onClick={() =>
                                moveToNextQuestion(single_assessment)
                              }
                              className="py-3 next-btn px-8 md:px-16 rounded-lg ml-8 md:ml-16 hover:bg-darkBlue hover:text-white active:text-white active:bg-darkBlue text-darkBlue border border-darkBlue text-lg"
                              id="next-button"
                            >
                              {getQuestionsmutation.isLoading ? (
                                "Please wait..."
                              ) : (
                                <>
                                  {" "}
                                  {t("next")}{" "}
                                  <i className="bi bi-chevron-double-right ml-3"></i>{" "}
                                </>
                              )}
                            </button>
                          ) : (
                            <>
                              {isSubmitting ? (
                                <button className="py-3 px-4 md:px-16 rounded-lg ml-8 md:ml-16  border  bg-gray-200 text-lg">
                                  {t("processing")}
                                </button>
                              ) : (
                                <button
                                  id="submit-button"
                                  data-te-toggle="modal"
                                  data-te-target={`#modal-${single_assessment.id}`}
                                  data-te-ripple-init
                                  data-te-ripple-color="light"
                                  style={{
                                    backgroundColor:
                                      brandedClient?.primary_colour ||
                                      undefined,
                                  }}
                                  className="py-3 px-4 md:px-16 rounded-lg ml-8 md:ml-16 text-white border hover:text-white active:text-white bg-darkBlue text-lg"
                                >
                                  {t("submit")}{" "}
                                  <i className="bi bi-chevron-double-right ml-3"></i>
                                </button>
                              )}
                              <SubmitConfirmModal
                                id={`modal-${single_assessment.id}`}
                                lastQuestion={questions[questions?.length - 1]}
                                submitAssessment={() =>
                                  submitAssessment(single_assessment)
                                }
                              />
                            </>
                          )}
                          {showunusualModal && (
                            <UnsuspiciousActivityModal
                              SetShowUnusualModal={SetShowUnusualModal}
                            />
                          )}
                          {showResizeModal && (
                            <ResizeWindowModal
                              setShowResizeModal={setShowResizeModal}
                            />
                          )}
                        </div>
                      </div> */}

                    <div className="mt-12 md:mt-[130px] flex flex-col md:flex-row md:justify-end items-center gap-4 md:gap-0 w-full">
                      <div className="flex flex-col md:flex-row items-center w-full md:w-auto gap-4">
                        <QuestionIndexGotoModal
                          id={`leftBottomModal-${single_assessment.id}`}
                          questions={questions}
                          activeQuestion={assessment.questionNumber}
                          gotoQuestion={gotoQuestion}
                          isLoading={getQuestionsmutation.isLoading}
                        />
                        <button
                          onClick={() =>
                            flagIncorrectQuestion(single_assessment.id)
                          }
                          className="bg-gray-200 bi bi-flag py-2 px-3 rounded-lg text-base w-full md:w-auto mb-2 md:mb-0 md:mr-12"
                        >
                          &nbsp; {t("flag-question-text")}
                        </button>
                        <div className="flex flex-col sm:flex-row items-center w-full md:w-auto gap-4 md:gap-4">
                          <button
                            className="bi bi-calculator-fill text-green-900 text-3xl md:text-4xl mb-2 md:mb-0 md:mr-16"
                            onClick={handleOpenModal}
                          ></button>
                          {openModal && (
                            <CalculatorModal closeModal={handleCloseModal} />
                          )}
                          <button
                            onClick={() =>
                              moveToPrevQuestion(single_assessment)
                            }
                            className="py-2 px-4 md:px-16 rounded-lg text-darkBlue hover:text-white active:text-white hover:bg-darkBlue active:bg-darkBlue border border-darkBlue text-base w-full md:w-auto mb-2 md:mb-0"
                          >
                            <i className="bi bi-chevron-double-left mr-2"></i>{" "}
                            {t("prev")}
                          </button>
                          {questions.length - 1 !== index ? (
                            <button
                              onClick={() =>
                                moveToNextQuestion(single_assessment)
                              }
                              className="py-2 next-btn px-4 md:px-16 rounded-lg hover:bg-darkBlue hover:text-white active:text-white active:bg-darkBlue text-darkBlue border border-darkBlue text-base w-full md:w-auto mb-2 md:mb-0"
                              id="next-button"
                              data-test-id={`next-button-${single_assessment.id}`}
                            >
                              {getQuestionsmutation.isLoading ? (
                                "Please wait..."
                              ) : (
                                <>
                                  {" "}
                                  {t("next")}{" "}
                                  <i className="bi bi-chevron-double-right ml-2"></i>{" "}
                                </>
                              )}
                            </button>
                          ) : (
                            <>
                              {isSubmitting ? (
                                <button className="py-2 px-4 md:px-16 rounded-lg border bg-gray-200 text-base w-full md:w-auto mb-2 md:mb-0">
                                  {t("processing")}
                                </button>
                              ) : (
                                <button
                                  data-test-id={`submit-button-${single_assessment.id}`}
                                  id="submit-button"
                                  data-te-toggle="modal"
                                  data-te-target={`#modal-${single_assessment.id}`}
                                  data-te-ripple-init
                                  data-te-ripple-color="light"
                                  style={{
                                    backgroundColor:
                                      brandedClient?.primary_colour ||
                                      undefined,
                                  }}
                                  className="py-2 px-4 md:px-16 rounded-lg text-white border hover:text-white active:text-white bg-darkBlue text-base w-full md:w-auto mb-2 md:mb-0"
                                >
                                  {t("submit")}{" "}
                                  <i className="bi bi-chevron-double-right ml-2"></i>
                                </button>
                              )}
                              <SubmitConfirmModal
                                id={`modal-${single_assessment.id}`}
                                lastQuestion={
                                  questions[questions?.length - 1]
                                }
                                submitAssessment={() =>
                                  submitAssessment(single_assessment)
                                }
                              />
                            </>
                          )}
                          {showunusualModal && (
                            <UnsuspiciousActivityModal
                              SetShowUnusualModal={SetShowUnusualModal}
                            />
                          )}
                          {showResizeModal && (
                            <ResizeWindowModal
                              setShowResizeModal={setShowResizeModal}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                }
              })
            }
          </div>
          {assessment?.isTimedOut && !assessment?.isEnded && <TimeOutModal />}
          {assessment?.isEnded && <AssessmentEndedModal />}
          {assessment?.isCompleted && <CompletedAssessmentModal />}
          {assessment?.isTerminated && <AssessmentTerminationModal />}
          <PreviewExamModal
            minutes={minutes}
            hours={hours}
            seconds={seconds}
            assessment={assessment}
            submitAssessment={submitAssessment}
          />
        </section>
      </>
      : <ScaleLoader />}
    </div>
  );
};

export default CandidateAssessment;
